import { render, staticRenderFns } from "./RegistrarMovimientoArmaDialogComponent.vue?vue&type=template&id=752bdd3d"
import script from "./RegistrarMovimientoArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarMovimientoArmaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports